import { Swiper } from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import { KenBurns } from './kenBurns';

document.addEventListener('DOMContentLoaded', () => {
  const kenBurnsElement = document.querySelector('.ken-burns');
  if (kenBurnsElement) {
    new KenBurns('.ken-burns', {
      burnsDuration: 15, // ズーム/パンの時間
      transitionTime: 2, // 画像切り替え時間
      timeout: 5, // 次のスライドまでの待機時間
    });
  }
  // Swiperの初期化（スクロールアニメーションとは独立して実行）
  const mvSwiperElement = document.querySelector<HTMLElement>('.mv-swiper');
  if (mvSwiperElement) {
    new Swiper(mvSwiperElement, {
      modules: [Autoplay, EffectFade],
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      // 止まっている時間
      autoplay: {
        delay: 3000,
      },
      // フェードしている時間
      speed: 3000,
    });
  }

  // スクロールアニメーション
  const section = document.querySelector<HTMLElement>(
    '[data-scroll-section="mv"]'
  );
  const text1 = document.querySelector<HTMLElement>(
    '[data-fade-target="mv-text"]'
  );
  const text2 = document.querySelector<HTMLElement>(
    '[data-fade-target="mv-text-1"]'
  );

  if (!section || !text1 || !text2) return;

  // スクロール開始位置・終了位置（単位：ビューポート高さ）
  const START_VH = 0.2; // 変化開始
  const END_VH = 1; // 変化終了

  // アニメーションの最大値
  const MAX_TRANSLATE_Y_OUT = -30; // 1つ目：0px → -30px（上に消える）
  const MAX_TRANSLATE_Y_IN = 30; // 2つ目：30px → 0px（下から出てくる）
  const MAX_BLUR = 20;

  let ticking = false;

  // iOSアドレスバー変動によるチラつき防止: viewport高さをキャッシュ
  let cachedVh = window.innerHeight;
  let lastWidth = window.innerWidth;

  function update() {
    if (!section || !text1 || !text2) return;

    const rect = section.getBoundingClientRect();
    const vh = cachedVh;

    // 親コンテナがどれだけ上にスクロールしたか（0〜300vh）
    const scrolled = -rect.top;

    // 100dvh〜200dvh を 0〜1 に正規化
    let progress = (scrolled - START_VH * vh) / ((END_VH - START_VH) * vh);
    progress = Math.min(1, Math.max(0, progress)); // 0〜1 にクランプ

    // ===== 1つ目：くっきり → モヤで上に消える =====
    const t1TranslateY = MAX_TRANSLATE_Y_OUT * progress; // 0 → -30
    const t1Blur = MAX_BLUR * progress; // 0 → 20
    const t1Opacity = 1 - progress; // 1 → 0
    const t1Visibility = progress >= 1 ? 'hidden' : 'inherit';

    text1.style.transform = `translate3d(0, ${t1TranslateY}px, 0)`;
    text1.style.filter = t1Blur === 0 ? 'none' : `blur(${t1Blur}px)`;
    text1.style.opacity = `${t1Opacity}`;
    text1.style.visibility = t1Visibility;

    // ===== 2つ目：モヤ状態で下から出てきて、くっきりで止まる =====
    // progress 0: 30px, blur 20, opacity 0（下 & モヤ & 見えない）
    // progress 1: 0px, blur 0, opacity 1（中央 & くっきり）
    const t2TranslateY = MAX_TRANSLATE_Y_IN * (1 - progress); // 30 → 0
    const t2Blur = MAX_BLUR * (1 - progress); // 20 → 0
    const t2Opacity = progress; // 0 → 1
    const t2Visibility = progress <= 0 ? 'hidden' : 'inherit';

    text2.style.transform = `translate3d(0, ${t2TranslateY}px, 0)`;
    text2.style.filter = t2Blur === 0 ? 'none' : `blur(${t2Blur}px)`;
    text2.style.opacity = `${t2Opacity}`;
    text2.style.visibility = t2Visibility;

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  // 横幅変更時のみキャッシュを更新（iOSアドレスバーは高さのみ変動）
  function onResize() {
    const currentWidth = window.innerWidth;
    if (currentWidth !== lastWidth) {
      lastWidth = currentWidth;
      cachedVh = window.innerHeight;
      update();
    }
  }

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onResize);

  // 初期状態反映
  update();
});
